<div class="popup" *ngIf="visible">
  <div class="popup-content">
    <h3>Plain text only</h3>
    <p>
      HTML tags are not allowed in chat messages. This chat session will be closed.
    </p>
    <button (click)="closePopup()">Close</button>
  </div>
</div>